export enum AgentType {
  ORCHESTRATOR = 'orchestrator',
  CODER = 'coder',
  TESTER = 'tester',
  DEPLOYER = 'deployer',
}

export enum TaskStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export interface Agent {
  name: string;
  description: string;
  capabilities: string[];
}

export interface AgentTask {
  task_id: string;
  agent_type: AgentType;
  status: TaskStatus;
  requirements: string;
  framework?: string;
  features?: string[];
  result?: any;
  execution_time?: number;
  error?: string;
  created_at: string;
  completed_at?: string;
}

export interface AgentTaskRequest {
  task_type: string;
  requirements: string;
  framework?: string;
  features?: string[];
  additional_data?: Record<string, any>;
}

export interface OrchestrationRequest {
  project_type: string;
  requirements: string;
  framework: string;
  features: string[];
  include_tests?: boolean;
  include_deployment?: boolean;
  target_platform?: string;
}

export interface AgentResponse {
  success: boolean;
  task_id: string;
  agent_type: string;
  result: Record<string, any>;
  execution_time: number;
  error?: string;
}

export interface AgentStatus {
  agents_available: boolean;
  enhanced_ai_available: boolean;
  deployment_available: boolean;
  auth_available: boolean;
  available_agents: string[];
  message: string;
}

export interface AgentsState {
  agents: Agent[];
  tasks: AgentTask[];
  currentTask: AgentTask | null;
  status: AgentStatus | null;
  loading: boolean;
  error: string | null;
}
